// Layout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import ProfileNavbar from "../ProfileNavbar/ProfileNavbar";
import Header from "../Header/Header";
import AdminProfileNavbar from "../ProfileNavbar/AdminProfileNavbar";
import AdminHeader from "../Header/AdminHeader";

const AdminLayout = () => {
  return (
    <div className="dashboard">
        <AdminProfileNavbar />
      <div className="dashRightView">
        <AdminHeader />
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
